import CustomLink from "../../Components/CustomLink";
import Language from "./Language";
import { logo } from "../../Data/Images/Home";

const ProductHeader = () => {
  return (
    <div className="t-sticky t-top-0 t-z-10 t-w-full t-bg-secondary t-flex t-items-center t-justify-center t-py-2">
      <div className="container t-flex t-items-center t-justify-center">
        <CustomLink to="/">
          <img src={logo} alt="" width={60} />
        </CustomLink>
        <div className="t-ml-auto">
          <Language />
        </div>
      </div>
    </div>
  );
};

export default ProductHeader;
